import { FunctionComponent } from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const EmptyTableState: FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <Typography sx={{ textAlign: 'center' }} variant="h5">
      {t('not-found-result')}
    </Typography>
  )
}
